import React from 'react'

const SvgLogo = props => (
  <svg width={18} height={12} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.475.008A2.92 2.92 0 0 1 15.32 2.27H18v1.3h-2.68a2.92 2.92 0 0 1-5.69 0H0v-1.3h9.63A2.92 2.92 0 0 1 12.475.008zM10.84 2.92a1.63 1.63 0 1 0 3.26 0 1.63 1.63 0 0 0-3.26 0zM5.05 6.06a2.91 2.91 0 0 0-2.84 2.27H0v1.3h2.21a2.92 2.92 0 0 0 5.69 0H18v-1.3H7.9a2.93 2.93 0 0 0-2.85-2.27zM3.542 9.6A1.63 1.63 0 1 0 6.558 8.36a1.63 1.63 0 0 0-3.016 1.238z"
      fill="#fff"
    />
  </svg>
)

export default SvgLogo
